import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import StudentList from './pages/StudentList';
import RegisterStudent from './pages/RegisterStudent';
import CaptureStudentFace from './pages/CaptureStudentFace';
import TakeAttendance from './pages/TakeAttendance';
import RegisterVenueLocation from './pages/RegisterVenueLocation';
import VenueLocationChangeRequests from './pages/VenueLocationChangeRequests';
import ViewVenueLocationChangeRequest from './pages/ViewVenueLocationChangeRequest';
import NavBar from './components/NavBar';
import Login from './pages/Login';
import TeacherLogin from './pages/TeacherLogin';
import TeacherHome from './pages/TeacherHome';

function AppContent() {
  const location = useLocation();
  const hideNav = location.pathname === '/' || location.pathname === '/teacher-login' || location.pathname === '/register-venue-location' || location.pathname === '/venue-location-change-requests' || location.pathname.startsWith('/view-venue-location-change-request/');

  return (
    <div className="min-h-screen bg-gray-50">
      {!hideNav && <NavBar />}
      <main style={{ marginTop: hideNav ? 0 : 24 }}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/teacher-login" element={<TeacherLogin />} />
          <Route path="/home" element={<TeacherHome />} />
          <Route path="/students" element={<StudentList />} />
          <Route path="/registerstudent" element={<RegisterStudent />} />
          <Route path="/capturestudentface" element={<CaptureStudentFace />} />
          <Route path="/takeattendance" element={<TakeAttendance />} />
          <Route path="/register-venue-location" element={<RegisterVenueLocation />} />
          <Route path="/venue-location-change-requests" element={<VenueLocationChangeRequests />} />
          <Route path="/view-venue-location-change-request/:id" element={<ViewVenueLocationChangeRequest />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
